import React from 'react';

import './InfoBar.css'
import onlineIcon from '../../Icons/onlineIcon.png'
import closeIcon from '../../Icons/closeIcon.png'


function InfoBar({room}){
    return(
        <div className='infoBar'>
<div className='leftInnerContainer'>
<img src={onlineIcon} alt="onlineIcon" className='onlineIcon'/>
    <h3>Room Name: <strong>{room}</strong></h3>
</div>
<div className=' rightInnerContainer'>
<a href="/"><img src={closeIcon} alt="x"/></a>
</div>
        </div>
    )
}
export default InfoBar